export const optimumFrictionConstants = {
    OPTIMUM_FRICTION_PREVIEW_TRAINING_IMPORT_REQUEST:"OPTIMUM_FRICTION_PREVIEW_TRAINING_IMPORT_REQUEST",
    OPTIMUM_FRICTION_PREVIEW_TRAINING_IMPORT_COMPLETE:"OPTIMUM_FRICTION_PREVIEW_TRAINING_IMPORT_COMPLETE",

    OPTIMUM_FRICTION_COMMIT_TRAINING_IMPORT_REQUEST:"OPTIMUM_FRICTION_COMMIT_TRAINING_IMPORT_REQUEST",
    OPTIMUM_FRICTION_COMMIT_TRAINING_IMPORT_COMPLETE:"OPTIMUM_FRICTION_COMMIT_TRAINING_IMPORT_COMPLETE",

    OPTIMUM_FRICTION_CLEAR_TRAINING_IMPORT:"OPTIMUM_FRICTION_CLEAR_TRAINING_IMPORT",

    OPTIMUM_FRICTION_GET_TRAINING_IMPORTS_REQUEST:"OPTIMUM_FRICTION_GET_TRAINING_IMPORTS_REQUEST",
    OPTIMUM_FRICTION_GET_TRAINING_IMPORTS_COMPLETE:"OPTIMUM_FRICTION_GET_TRAINING_IMPORTS_COMPLETE",

    OPTIMUM_FRICTION_GET_REPORT_REQUEST:"OPTIMUM_FRICTION_GET_REPORT_REQUEST",
    OPTIMUM_FRICTION_GET_REPORT_COMPLETE:"OPTIMUM_FRICTION_GET_REPORT_COMPLETE",

    OPTIMUM_FRICTION_GET_REPORT_EXPORT_REQUEST:"OPTIMUM_FRICTION_GET_REPORT_EXPORT_REQUEST",
    OPTIMUM_FRICTION_GET_REPORT_EXPORT_COMPLETE:"OPTIMUM_FRICTION_GET_REPORT_EXPORT_COMPLETE",
    OPTIMUM_FRICTION_CLEAR_REPORT_EXPORT:"OPTIMUM_FRICTION_CLEAR_REPORT_EXPORT",

    // Only Successful grants accreditation. The other values the file carries are Not Evaluated,
    // Booked and blank, and they are kept as they read rather than turned into a flag here.
    OPTIMUM_FRICTION_ACCREDITED_STATUS:"Successful",
}
